import React from "react";
import Ellipse1 from "../../assets/Ellipse-1.svg";
import Ellipse2 from "../../assets/Ellipse-2.svg";
import Ellipse3 from "../../assets/Ellipse-3.svg";
import LogoContainer from "../../assets/LogoContainer.svg";
import "./TakeDeepBreath.css";

export const TakeDeepBreath = () => {
  return (
    <div className="take-deep-breath-container">
      <div className="ellipes-1">
        <img src={Ellipse1} alt="Ellipse 1" class="ripple-img"/>
      </div>
      <div className="ellipes-2">
        <img src={Ellipse2} alt="Ellipse 2" class="ripple-img" />
      </div>
      <div className="ellipes-3">
        <img src={Ellipse3} alt="Ellipse 3"  class="ripple-img"/>
      </div>
      <div className="logo-container-loading">
        <img src={LogoContainer} alt="Logo" />
        <p className="tagline-text">Take a deep breath in, let the air out. Arrive now</p>
      </div>
    </div>
  );
};
